export default {
  public: "Public",
  re_new: "Update",
  live_preview: {
    auction_overview: "Description of auction",
    period: "Period of the event",
    end_time_varies: "Not all koi have the same ending time.",
    attention: `<p class="mb__text-lg mb__text-center">About Keeping Koi in Japan</p><p class="mb__m-bottom-sm">Basically, <span class="EM">we are not able to keep Koi in Japan a long term</span> that are not indicated as <span class="EM">"Including Keeping Charges ", "Possible to Keep in Japan for 50,000yen", "For Koi Show in Japan"</span> etc. in the description of the Koi for the auction.<br>If you need long-term (more than 2 months) keeping in Japan due to circumstances beyond your control, please email or call us before bidding.<br><span class="EM">We shall not be liable for death, disease, injury or/and quality decline of the Nishikigoi during the period of the keeping in Japan.</span><br>If this is condition stated, that is, the order must be shipped within one month after the successful bid, furthermore the delivery date will exceed one month from the end of auction due to the customer's circumstances, we will not be liable for the death, quality decline, and the death on arrival and so on.</p><p class="mb__asterisk">We will refund the whole amount when Koi sold as female was found out to be male.</p>`,
    auction_carp_list: "List of Koi on auction",
    all_producers: "All breeders",
    fish_farm: "💱玉浦養魚場💱",
    koi_farm: "💱面迫養鯉場💱",
    all_breeds: "All varieties",
    read_and_white: "💱紅白💱",
    taisho_three_colors: "💱大正三色💱",
    all_genders: "Both sexes",
    male: "male",
    female: "female",
    unknown: "unknown",
    price: "Price",
    the_following: "or less",
    show_only_the_koi_you_bid_on: "Show only koi on which I have bid.",
    display: "Display",
    reset: "Reset",
    in_the_case: "💱件中💱",
    view: "💱件を表示💱",
    list: "List",
    thumbnail: "Thumbnail",
    submitted_from_narita_fish_farm: "This Koi is at Narita Koi Farm",
    parent_carp: "Offspring Of",
    remaining: "Remainder",
    starting_price: "Opening price",
    current_price: "Current price",
    photograph: "Photo",
    movie: "Movie",
    favorite: "Favorite",
    bid: "Bid",
    bid_content:
      "To enter a bid on a koi up for auction as shown below, enter the amount of your bid and press the Bid button.",
    favorite_button: "List of Favorites",
    breeder: "💱玉浦養魚場（成田養魚園より出品）💱",
    koi_data: "💱紅白 2歳 メス 54cm / 親鯉：レッドアイ💱",
    note_text: "💱2023年4月までの預かり料込（任意）💱",
    bid_history: "Bidding history",
    notice_bid_success: "💱様、あなたは現在💱",
    highest_bidder: "Highest bidder",
    is: "💱です。💱",
    bid_amount: "Bid",
    please_enter_your_bid_amount: "Please enter your screen name and your bid.",
    nickname: "Nickname",
    rule_nickname: "💱半角英数5〜15文字（- _ ! ? # . 利用可）💱",
    error_price_below:
      "💱入札額が現在価格を下回っているため、入札できませんでした。💱",
    terms_of_service: "Terms of Use Agreement",
    agree_about: "I agree",
    residing_overseas_notice:
      "Customers who live outside of Japan may only participate in auctions if they are authorized dealers of Narita Koi Farms.",
    bid_amount_notice:
      "It is not possible for a customer to correct the amount of a bid themselves. In the event that you need to correct the amount of a bid,",
    contact: "Please contact",
    button_cancel: "Cancel",
    to_bid_on: "💱で入札する💱",
    final_bid_confirmation: "Finalize your bid",
    bid_confirmation_notice:
      "You are entering a bid on the koi up for auction as shown below. Once entered, a bid may not be withdrawn.",
    thank_you: "💱入札ありがとうございます💱",
    bid_success_notice: `💱入札が成功いたしました。<br />
      入札中のオークション一覧から現在価格のご確認が随時行えます。💱`,
    close_button: "Close",
    display_number_of_total:
      'Showing <span class="mb__bold">{start}–{end}</span> of <span class="mb__bold">{total}</span> items.',
  },
  event_preview: {
    event_overview: "Description of event",
    event_date: "Day of the event",
    pre_purchase_request_application: "Request for prepurchase",
    to: "Until {datetime}",
    list_event_carp: "List of Koi for sale during event",
    all_producers: "All breeders",
    fish_farm: "💱玉浦養魚場💱",
    koi_farm: "💱面迫養鯉場💱",
    all_breeds: "All varieties",
    read_and_white: "💱紅白💱",
    taisho_three_colors: "💱大正三色💱",
    all_genders: "Both sexes",
    male: "male",
    female: "female",
    unknown: "unknown",
    female_now: "female now",
    the_following: "or less",
    koi_applied_purchase: "💱購入希望申込をした鯉のみ表示💱",
    display: "Display",
    reset: "Reset",
    in_the_case: "💱件中💱",
    view: "💱件を表示💱",
    list: "List",
    thumbnail: "Thumbnail",
    printing: "Print",
    parent_carp: "Offspring Of",
    photograph: "Photo",
    movie: "Movie",
    want_to_buy: "Purchase request",
    applying_for_name: "people have requested it",
    store_event: "💱店頭イベント💱",
    purchase_requests_notice:
      "This will request prepurchase of the koi exhibited at the in-store event shown below. Do you wish to proceed with the request?",
    button_cancel: "Cancel",
    button_apply: "Request",
    all_koi: "All Koi",
    purchase: "koi for which a purchase request has been submitted",
    no_purchase: "koi for which a purchase request has not been submitted",
    price: "price",
    display_number_of_total:
      'Showing <span class="mb__bold">{start}–{end}</span> of <span class="mb__bold">{total}</span> items.',
    competitive_bidding: "Competitive bidding",
    event_not_found: "No applicable data found.",
  },
  show_preview: {
    page_title: "Show Winners",
    introduction: `Here are some of the prize-winning nishikigoi that are available from Narita Koi Farms.<br />
    Our nishikigoi have won recognition at numerous national breeder shows, including the well known All Japan Sogo Nishikigoi Show, the Young Koi Show, and the Rinyukai.`,
    all_fairs: "All breeder shows",
    tokyo_games: "Tokyo Games",
    wakai_conference: "If carp conference",
    international_nishikigoi_show: "International Nishikigoi Fair",
    friends_club: "Rinyukai",
    tokai_area: "Tokai district",
    asia_up: "Asia up",
    international_juvenile_fish_fair: "International young fish competition",
    all_competitions: "All competitions",
    all_producers: "All producers",
    owner_name: "Owner name",
    express: "Display",
    reset: "Reset",
    in_the_case: "Of",
    view: "Show results",
    new_arrival_order: "Newest",
    old_order: "Oldest",
    agency: "Handled:",
    looks: "Dear",
    close: "Close",
    display_number_of_total:
      'Showing <span class="mb__bold">{start}〜{end}</span> of <span class="mb__bold">{total}</span> items.',
  },
  store_preview: {
    product_name: "Product Name",
    price: "Price",
    quantity: "Quantity",
    add_to_cart: "💱カートに入れる💱",
    to_order_procedure: "💱ご注文手続きへ💱",
    add_shipping: "Shipping fees and returns policy",
    notation:
      "Regarding descriptions based on the Specified Commercial Transactions Law",
    product_list: "Product list",
    nishikigoi_feed: "錦鯉飼料",
    feed_for_larval_and_juvenile_fish: "育成飼料",
    title: "Breeding supplies store",
    back: "back to previous page",
    category: "Category",
    option_names: "Option",
  },
  new_preview: {
    notice_list: "💱お知らせ一覧💱",
  },
  blog_preview: {
    blog_list: "💱ブログ一覧💱",
    creator_introduce: "About the author of this article",
  },
};
